import { schema } from 'normalizr';
import { coreMemberSerializer } from './coreMember.serializer';
import { memberProfileSerializer } from './memberProfile.serializer';

export const memberSchema = new schema.Entity(
  'members',
  {},
  {
    processStrategy: coreMemberSerializer,
  }
);

export const createMemberSchema = (
  customSerializer: (coreSerializer: any) => any
) =>
  new schema.Entity(
    'members',
    {},
    {
      processStrategy: customSerializer(memberProfileSerializer),
    }
  );

export const memberProfileSchema = new schema.Entity(
  'members',
  {},
  {
    processStrategy: memberProfileSerializer,
  }
);
